const styles = {
  root: {
    paddingBottom: 16,
  },
};

export default styles;
